import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse, IRailPreferencesResponse } from "../../Orchestrator/Types/Index";
import { ISpecialAssistancePref } from "../../Orchestrator/Types/Interface/IRailPreference";
import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";


export async function getSpecialAssistancePref(): Promise<IApiResponse<{ specialAssistancePref: ISpecialAssistancePref[] }>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.getSpecialAssistancePref;
    return await apiRequest<{ specialAssistancePref: ISpecialAssistancePref[] }>(endpoint, 'GET');
}

export async function savePersonalizeExperience(payload: any, userId: number): Promise<IApiResponse<IRailPreferencesResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.savePersonalizeExperience(userId);

    return await apiRequest<IRailPreferencesResponse>(endpoint, 'PUT', {
        body: JSON.stringify(payload)
    });
}
